<template>
  <hr v-if="!suppressMessage" />
  <div class="spa-itinerary">
    <div class="row mb-3" v-if="!suppressMessage">
      <div class="col-24">
        <h3>{{ title }}</h3>
      </div>
    </div>
    <div class="row" v-if="!suppressMessage">
      <div class="col-24">
        <div v-if="isSpaDay">
          <info-box v-bind:type="'alert'">
            <template v-slot:body>
              <div class="d-flex flex-column justify-content-between">
                <span class="heading">
                  Please arrive for your spa day 15 minutes before it is due to
                  commence.
                </span>
                <p>
                  Rockliffe Hall reserves the right to amend treatment start
                  times subject to availability.
                </p>
              </div>
            </template>
          </info-box>
        </div>
        <div v-else>
          <info-box v-bind:type="'alert'">
            <template v-slot:body>
              <div class="d-flexf flex-column justify-content-between">
                <span class="heading">
                  Please arrive for your treatment 15 minutes before it is due
                  to commence.
                </span>
                <p>
                  Rockliffe Hall reserves the right to amend treatment start
                  times subject to availability.
                </p>
              </div>
            </template>
          </info-box>
        </div>
      </div>
    </div>

    <div class="row" v-bind:class="{ 'mt-4': !suppressMessage }">
      <div
        v-bind:class="columnClass()"
        v-for="(guest, guestIndex) in search.guests"
      >
        <h3 class="mb-3">{{ guest.firstName }}'s itinerary</h3>

        <ul>
          <li class="item" v-for="(tt, tti) in times(guest, guestIndex)">
            <span class="d-flex">
              <span class="time">{{ tt.StartTime }}</span>
              <span class="treatment d-inline-flex">{{ tt.DisplayName }}</span>
              <a v-if="tt.Edit" class="spa-edit" v-bind:href="tt.Edit">Edit</a>
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import InfoBox from "@/shared/components/InfoBox.vue";
import { store } from "../store/index";

import { _ } from "vue-underscore";

export default {
  name: "SpaItinerary",
  props: {
    title: String,
    isSpaDay: Boolean,
    suppressMessage: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    InfoBox,
  },

  computed: {
    hasAddOns() {
      return this.search.groupAddOns != null && this.search.groupAddOns.length;
    },
    session() {
      return store.getters.session;
    },
    search() {
      return store.getters.search;
    },
    booking() {
      return store.getters.booking;
    },
  },
  methods: {
    columnClass() {
      let def = "col-24 col-md-12";

      if (this.suppressMessage) {
        if (this.search.guests.length == 3) {
          def = "col-24 col-lg-8";
        }
      }
      //    else if (this.search.guests.length == 4) {
      //        def = 'col-24 col-lg-6';
      //    }
      //}

      if (!this.suppressMessage) {
        def += " mb-4";
      }

      return def;
    },
    times(guest, gi) {
      var result = [];

      if (guest.spaDayArrivalTime?.selectedItem != null) {
        result.push({
          DisplayName: "Arrival",
          StartTime: this.formatTime(
            guest.spaDayArrivalTime.selectedItem.StartDateTime
          ),
          Edit: this.getEditRoute("arrival"),
        });
      }

      if (guest.startTime?.TreatmentTimes != null) {
        for (let gi = 0; gi < guest.startTime.TreatmentTimes.length; gi++) {
          var item = guest.startTime.TreatmentTimes[gi];

          result.push({
            DisplayName: this.treatmentName(guest, item),
            StartTime: this.formatTime(item.StartTime),
            Edit: this.getEditRoute("treatments"),
          });
        }
      }

      if (this.search.restaurant != null) {
        result.push({
          DisplayName: this.search.restaurant.displayName,
          StartTime: moment(
            this.search.restaurant.selectedTime.TimeSlot
          ).format("HH:mm"),
          Edit: this.getEditRoute("dining"),
        });
      }

      if (guest.spaArrivalTime != null) {
        result.push({
          DisplayName: "Spa Garden",
          StartTime: moment(guest.spaArrivalTime.StartDateTime).format("HH:mm"),
          Edit: this.getEditRoute("garden"),
        });
      }

      if (this.search.selectedMudExtras != null) {
        if (
          this.search.selectedMudExtras.guestIndexes.find(
            (item) => item == gi
          ) != null
        ) {
          result.push({
            DisplayName:
              this.search.selectedMudExtras.addOn.content.DisplayName,
            StartTime: moment(
              this.search.selectedMudExtras.selection.StartDateTime
            ).format("HH:mm"),
            Edit: this.getEditRoute("add_ons"),
          });
        }
      }

      if (this.search.selectedGardenExtras != null) {
        if (
          this.search.selectedGardenExtras.guestIndexes.find(
            (item) => item == gi
          ) != null
        ) {
          result.push({
            DisplayName:
              this.search.selectedGardenExtras.addOn.content.DisplayName,
            StartTime: moment(
              this.search.selectedGardenExtras.selection.StartDateTime
            ).format("HH:mm"),
            Edit: this.getEditRoute("add_ons"),
          });
        }
      }

      if (this.search.selectedTreatmentExtras != null) {
        let guestExtras = this.search.selectedTreatmentExtras.filter(
          (item) => item.guestIndex == gi
        );

        for (let i = 0; i < guestExtras.length; i++) {
          let extra = guestExtras[i];

          result.push({
            DisplayName: extra.selection.treatment.DisplayName,
            StartTime: moment(extra.time.StartTime).format("HH:mm"),
            Edit: this.getEditRoute("add_ons"),
          });
        }
      }

      if (this.search?.spaDay?.EndTime != null) {
        result.push({
          DisplayName: "Departure",
          StartTime: moment(this.search.spaDay.EndTime, "HH:mm:ss").format(
            "HH:mm"
          ),
          Edit: null,
        });
      }

      return _.sortBy(result, function (item) {
        return moment(item.StartTime, "HH:mm");
      });
    },
    formatTime(input) {
      return moment(input).format("HH:mm");
    },
    treatmentName(guest, input) {
      let result = guest.treatments.find(
        (item) => item.duration.Id == input.AppointmentTypeID
      )?.treatment.DisplayName;
      return result;
    },
    getEditRoute(input) {
      if (!this.suppressMessage) {
        return;
      }

      var path = null;
      if (this.isSpaDay) {
        if (input === "arrival") {
          path = "spa_day_arrival_time";
        } else if (input === "dining") {
          path = "spa_day_dining";
        } else if (input === "garden") {
          path = "spa_day_garden";
        } else if (input === "treatments") {
          path = "spa_day_treatments";
        } else if (input === "add_ons") {
          path = "spa_day_add_ons";
        }
      } else {
        if (input === "treatments") {
          path = "spa_treatment_treatments";
        } else if (input === "add_ons") {
          path = "spa_treatment_add_ons";
        }
      }

      if (path != null) {
        var route = {
          name: path,
          params: {
            id: this.session.Id,
          },
        };

        let props = this.$router.resolve(route);

        return props.href;
      }
      return null;
    },
  },
};
</script>

<style scoped>
.spa-itinerary {
}

.spa-itinerary .spa-edit {
  border: none;
  background-color: transparent;
  position: absolute;
  right: 0%;
  top: 0%;
  height: 18px;
  text-indent: 0 !important;
  padding-left: 22px;
  width: auto !important;
  background-position: left 2px !important;
  background-size: 15px 15px;
  background-repeat: no-repeat;
  text-transform: uppercase;
  font-weight: bold;
  cursor: pointer !important;
  background-image: url("@/assets/img/booking/edit.svg");
}

.spa-itinerary .item {
  list-style: disc;
  margin-bottom: 15px;
  position: relative;
}

.spa-itinerary .item:before {
  display: block;
  content: "";
  width: 1px;
  height: 15px;
  background: black;
  position: absolute;
  left: -11px;
  top: -15px;
}

.spa-itinerary .item:first-child::before {
  display: none;
}

.spa-itinerary .item:last-child {
  margin-bottom: 0;
}

.spa-itinerary .time {
  font-weight: bold;
  width: 80px;
  min-width: 80px;
  display: inline-block;
}
</style>
